<ng-template #contentHeaderTemplate>
  <div class="row" *appIfHasAllPermissions="[PERMISSION.TIMETRACKING_TIMETRACKINGABSENCEREQUEST_CREATE_ALL]">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" routerLink="/time-tracking/absence-requests/personal/add">
        {{ 'authenticated.time_tracking.absence_requests.create_btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

<app-table id="dashboard.time-tracking.absence-requests.personal.index"></app-table>
